import { jsx as fe } from "react/jsx-runtime";
import * as X from "react";
import ie, { useState as W, useMemo as le, useCallback as U, useEffect as J } from "react";
import { c as he } from "../../index-C3-ZVs5E.js";
import { r as pe } from "../../index-C8-Y4gAa.js";
import { useElement as be, useMergeRefs as ge, buildThemeVariables as me } from "../utils.js";
var b = [], we = function() {
  return b.some(function(e) {
    return e.activeTargets.length > 0;
  });
}, xe = function() {
  return b.some(function(e) {
    return e.skippedTargets.length > 0;
  });
}, K = "ResizeObserver loop completed with undelivered notifications.", ze = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: K
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = K), window.dispatchEvent(e);
}, C;
(function(e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(C || (C = {}));
var g = function(e) {
  return Object.freeze(e);
}, Ee = /* @__PURE__ */ function() {
  function e(t, r) {
    this.inlineSize = t, this.blockSize = r, g(this);
  }
  return e;
}(), oe = function() {
  function e(t, r, n, i) {
    return this.x = t, this.y = r, this.width = n, this.height = i, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, g(this);
  }
  return e.prototype.toJSON = function() {
    var t = this, r = t.x, n = t.y, i = t.top, o = t.right, s = t.bottom, a = t.left, c = t.width, u = t.height;
    return { x: r, y: n, top: i, right: o, bottom: s, left: a, width: c, height: u };
  }, e.fromRect = function(t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(), $ = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, se = function(e) {
  if ($(e)) {
    var t = e.getBBox(), r = t.width, n = t.height;
    return !r && !n;
  }
  var i = e, o = i.offsetWidth, s = i.offsetHeight;
  return !(o || s || e.getClientRects().length);
}, Y = function(e) {
  var t;
  if (e instanceof Element)
    return !0;
  var r = (t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(r && e instanceof r.Element);
}, Re = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, S = typeof window < "u" ? window : {}, D = /* @__PURE__ */ new WeakMap(), Q = /auto|scroll/, ye = /^tb|vertical/, Oe = /msie|trident/i.test(S.navigator && S.navigator.userAgent), v = function(e) {
  return parseFloat(e || "0");
}, E = function(e, t, r) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), r === void 0 && (r = !1), new Ee((r ? t : e) || 0, (r ? e : t) || 0);
}, Z = g({
  devicePixelContentBoxSize: E(),
  borderBoxSize: E(),
  contentBoxSize: E(),
  contentRect: new oe(0, 0, 0, 0)
}), ae = function(e, t) {
  if (t === void 0 && (t = !1), D.has(e) && !t)
    return D.get(e);
  if (se(e))
    return D.set(e, Z), Z;
  var r = getComputedStyle(e), n = $(e) && e.ownerSVGElement && e.getBBox(), i = !Oe && r.boxSizing === "border-box", o = ye.test(r.writingMode || ""), s = !n && Q.test(r.overflowY || ""), a = !n && Q.test(r.overflowX || ""), c = n ? 0 : v(r.paddingTop), u = n ? 0 : v(r.paddingRight), l = n ? 0 : v(r.paddingBottom), h = n ? 0 : v(r.paddingLeft), R = n ? 0 : v(r.borderTopWidth), y = n ? 0 : v(r.borderRightWidth), M = n ? 0 : v(r.borderBottomWidth), N = n ? 0 : v(r.borderLeftWidth), O = h + u, T = c + l, m = N + y, w = R + M, d = a ? e.offsetHeight - w - e.clientHeight : 0, k = s ? e.offsetWidth - m - e.clientWidth : 0, A = i ? O + m : 0, H = i ? T + w : 0, x = n ? n.width : v(r.width) - A - k, p = n ? n.height : v(r.height) - H - d, z = x + O + k + m, f = p + T + d + w, B = g({
    devicePixelContentBoxSize: E(Math.round(x * devicePixelRatio), Math.round(p * devicePixelRatio), o),
    borderBoxSize: E(z, f, o),
    contentBoxSize: E(x, p, o),
    contentRect: new oe(h, c, x, p)
  });
  return D.set(e, B), B;
}, ce = function(e, t, r) {
  var n = ae(e, r), i = n.borderBoxSize, o = n.contentBoxSize, s = n.devicePixelContentBoxSize;
  switch (t) {
    case C.DEVICE_PIXEL_CONTENT_BOX:
      return s;
    case C.BORDER_BOX:
      return i;
    default:
      return o;
  }
}, Te = /* @__PURE__ */ function() {
  function e(t) {
    var r = ae(t);
    this.target = t, this.contentRect = r.contentRect, this.borderBoxSize = g([r.borderBoxSize]), this.contentBoxSize = g([r.contentBoxSize]), this.devicePixelContentBoxSize = g([r.devicePixelContentBoxSize]);
  }
  return e;
}(), ue = function(e) {
  if (se(e))
    return 1 / 0;
  for (var t = 0, r = e.parentNode; r; )
    t += 1, r = r.parentNode;
  return t;
}, Be = function() {
  var e = 1 / 0, t = [];
  b.forEach(function(s) {
    if (s.activeTargets.length !== 0) {
      var a = [];
      s.activeTargets.forEach(function(u) {
        var l = new Te(u.target), h = ue(u.target);
        a.push(l), u.lastReportedSize = ce(u.target, u.observedBox), h < e && (e = h);
      }), t.push(function() {
        s.callback.call(s.observer, a, s.observer);
      }), s.activeTargets.splice(0, s.activeTargets.length);
    }
  });
  for (var r = 0, n = t; r < n.length; r++) {
    var i = n[r];
    i();
  }
  return e;
}, j = function(e) {
  b.forEach(function(r) {
    r.activeTargets.splice(0, r.activeTargets.length), r.skippedTargets.splice(0, r.skippedTargets.length), r.observationTargets.forEach(function(i) {
      i.isActive() && (ue(i.target) > e ? r.activeTargets.push(i) : r.skippedTargets.push(i));
    });
  });
}, Se = function() {
  var e = 0;
  for (j(e); we(); )
    e = Be(), j(e);
  return xe() && ze(), e > 0;
}, I, ve = [], Ce = function() {
  return ve.splice(0).forEach(function(e) {
    return e();
  });
}, ke = function(e) {
  if (!I) {
    var t = 0, r = document.createTextNode(""), n = { characterData: !0 };
    new MutationObserver(function() {
      return Ce();
    }).observe(r, n), I = function() {
      r.textContent = "".concat(t ? t-- : t++);
    };
  }
  ve.push(e), I();
}, We = function(e) {
  ke(function() {
    requestAnimationFrame(e);
  });
}, L = 0, De = function() {
  return !!L;
}, _e = 250, Pe = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, ee = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], te = function(e) {
  return e === void 0 && (e = 0), Date.now() + e;
}, V = !1, Le = function() {
  function e() {
    var t = this;
    this.stopped = !0, this.listener = function() {
      return t.schedule();
    };
  }
  return e.prototype.run = function(t) {
    var r = this;
    if (t === void 0 && (t = _e), !V) {
      V = !0;
      var n = te(t);
      We(function() {
        var i = !1;
        try {
          i = Se();
        } finally {
          if (V = !1, t = n - te(), !De())
            return;
          i ? r.run(1e3) : t > 0 ? r.run(t) : r.start();
        }
      });
    }
  }, e.prototype.schedule = function() {
    this.stop(), this.run();
  }, e.prototype.observe = function() {
    var t = this, r = function() {
      return t.observer && t.observer.observe(document.body, Pe);
    };
    document.body ? r() : S.addEventListener("DOMContentLoaded", r);
  }, e.prototype.start = function() {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), ee.forEach(function(r) {
      return S.addEventListener(r, t.listener, !0);
    }));
  }, e.prototype.stop = function() {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), ee.forEach(function(r) {
      return S.removeEventListener(r, t.listener, !0);
    }), this.stopped = !0);
  }, e;
}(), q = new Le(), re = function(e) {
  !L && e > 0 && q.start(), L += e, !L && q.stop();
}, Me = function(e) {
  return !$(e) && !Re(e) && getComputedStyle(e).display === "inline";
}, Ne = function() {
  function e(t, r) {
    this.target = t, this.observedBox = r || C.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var t = ce(this.target, this.observedBox, !0);
    return Me(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(), Ae = /* @__PURE__ */ function() {
  function e(t, r) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = r;
  }
  return e;
}(), _ = /* @__PURE__ */ new WeakMap(), ne = function(e, t) {
  for (var r = 0; r < e.length; r += 1)
    if (e[r].target === t)
      return r;
  return -1;
}, P = function() {
  function e() {
  }
  return e.connect = function(t, r) {
    var n = new Ae(t, r);
    _.set(t, n);
  }, e.observe = function(t, r, n) {
    var i = _.get(t), o = i.observationTargets.length === 0;
    ne(i.observationTargets, r) < 0 && (o && b.push(i), i.observationTargets.push(new Ne(r, n && n.box)), re(1), q.schedule());
  }, e.unobserve = function(t, r) {
    var n = _.get(t), i = ne(n.observationTargets, r), o = n.observationTargets.length === 1;
    i >= 0 && (o && b.splice(b.indexOf(n), 1), n.observationTargets.splice(i, 1), re(-1));
  }, e.disconnect = function(t) {
    var r = this, n = _.get(t);
    n.observationTargets.slice().forEach(function(i) {
      return r.unobserve(t, i.target);
    }), n.activeTargets.splice(0, n.activeTargets.length);
  }, e;
}(), He = function() {
  function e(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof t != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    P.connect(this, t);
  }
  return e.prototype.observe = function(t, r) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Y(t))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    P.observe(this, t, r);
  }, e.prototype.unobserve = function(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Y(t))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    P.unobserve(this, t);
  }, e.prototype.disconnect = function() {
    P.disconnect(this);
  }, e.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}();
const de = ie[typeof document < "u" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"], Ie = (e) => {
  const t = X.useRef(e);
  return X.useEffect(() => {
    t.current = e;
  }), t;
}, Ve = typeof window < "u" && "ResizeObserver" in window ? (
  // @ts-ignore
  window.ResizeObserver
) : He;
function Fe() {
}
function Xe(e, t) {
  const r = $e(), n = Ie(t);
  return de(() => {
    let i = !1;
    const o = e && "current" in e ? e.current : e;
    if (!o) return Fe;
    function s(a, c) {
      i || n.current(a, c);
    }
    return r.subscribe(o, s), () => {
      i = !0, r.unsubscribe(o, s);
    };
  }, [e, r, n]), r.observer;
}
function qe() {
  let e = !1, t = [];
  const r = /* @__PURE__ */ new Map(), n = new Ve((i, o) => {
    t = t.concat(i);
    function s() {
      const a = /* @__PURE__ */ new Set();
      for (let c = 0; c < t.length; c++) {
        if (a.has(t[c].target)) continue;
        a.add(t[c].target);
        const u = r.get(t[c].target);
        u == null || u.forEach((l) => l(t[c], o));
      }
      t = [], e = !1;
    }
    e || window.requestAnimationFrame(s), e = !0;
  });
  return {
    observer: n,
    subscribe(i, o) {
      var s;
      n.observe(i);
      const a = (s = r.get(i)) !== null && s !== void 0 ? s : [];
      a.push(o), r.set(i, a);
    },
    unsubscribe(i, o) {
      var s;
      const a = (s = r.get(i)) !== null && s !== void 0 ? s : [];
      if (a.length === 1) {
        n.unobserve(i), r.delete(i);
        return;
      }
      const c = a.indexOf(o);
      c !== -1 && a.splice(c, 1), r.set(i, a);
    }
  };
}
let F;
const $e = () => F || (F = qe()), Ge = (e, t) => {
  const [r, n] = X.useState(() => {
    var i, o;
    const s = e && "current" in e ? e.current : e;
    return s ? [s.offsetWidth, s.offsetHeight] : [(i = void 0) !== null && i !== void 0 ? i : 0, (o = void 0) !== null && o !== void 0 ? o : 0];
  });
  return de(() => {
    const i = e && "current" in e ? e.current : e;
    i && n([i.offsetWidth, i.offsetHeight]);
  }, [e]), Xe(e, (i) => {
    const o = i.target;
    n([o.offsetWidth, o.offsetHeight]);
  }), r;
}, Ue = () => document.getElementById("graphapi-app-plate-root") || document.body, Je = ie.forwardRef(
  ({
    children: e,
    className: t,
    horizontalPaddingMedia: r,
    anchor: n,
    topOffset: i = 0,
    leftOffset: o = 0,
    plateMinWidth: s = 320,
    theme: a
  }, c) => {
    const { ref: u, element: l } = be(), h = ge(c, u), [R, y] = Ge(l), [M, N] = W(
      "hidden"
    ), [O, T] = W(), [m, w] = W(), [d, k] = W(0), A = Math.min(
      s,
      window.innerWidth - 2 * d
    ), H = window.innerWidth - 2 * d, x = le(Ue, []), p = U(() => {
      for (const f in r)
        window.matchMedia(f).matches && k(r[f]);
    }, [r]), z = U(() => {
      if (n) {
        p();
        const f = n.getBoundingClientRect(), B = f.top + f.height + i, G = f.left + o;
        B + y > window.innerHeight ? T(window.innerHeight - y - d) : T(B), G + R > window.innerWidth ? w(window.innerWidth - R - d) : w(G);
      }
    }, [
      n,
      o,
      d,
      y,
      R,
      i,
      p
    ]);
    return J(() => (window.addEventListener("resize", z), z(), () => {
      window.removeEventListener("resize", z);
    }), [z]), J(() => {
      N("visible");
    }, []), O === void 0 || m === void 0 ? null : pe.createPortal(
      /* @__PURE__ */ fe(
        "div",
        {
          className: he(
            "app:bg-neutral app:border app:border-border app:rounded-lg app:box-border app:pt-[--spacing(2.5)] app:px-2 app:pb-2 app:items-center app:text-left app:align-middle app:fixed app:top-0 app:left-0 app:z-[101] app:shadow-plate app:shadow-shadow",
            t
          ),
          style: {
            ...me(a),
            transform: `translate(${m}px,${O}px)`,
            minWidth: A,
            maxWidth: H,
            visibility: M
          },
          ref: h,
          children: e
        }
      ),
      x
    );
  }
), Ke = Je;
Ke.themeKeys = {
  "color-primary": !0,
  "color-neutral": !0,
  "color-border": !0,
  "color-shadow": !0,
  spacing: !0
};
export {
  Ke as Plate
};
